<template>
  <div calss="box">
    <!-- 首页上半部分 -->
    <el-row type="flex" class="row-bg" justify="space-between">
      <div class="block marr10">
        <el-carousel height="450px" arrow="always" :interval="3000">
          <el-carousel-item v-for="(item, index) in imgList" :key="index">
            <div @click="gonew(item.id)" class="cursor" style="width:590px; height:450px">
              <img :src="baseURL + '/file/getFile?fileName=' + item.picturePath" alt="" style="width:100%; height:90%" />
              <div style="padding-left: 5px; padding-top: 3px; padding-bottom: 3px; background-color:rgba(220, 220, 220, 0.4); font-size: 16px;">{{ item.title }}</div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <notice class="notice" />
    </el-row>
    <!-- 首页下半部分 -->
    <el-row type="flex" class="row-bg" justify="space-between">
      <work class="work" />
      <dynamic class="dynamic" />
      <other class="other" />
    </el-row>

    <!-- 定位fixed -->
    <div class="fixed1">
      <a href="#"><img src="../../assets/images/gzh.jpg" alt=""/></a>
    </div>
    <div class="fixed2">
      <a href="#"><img src="../../assets/images/wb.jpg" alt=""/></a>
    </div>
  </div>
</template>
<script>
import notice from '../../views/notice.vue'
import work from '../../views/work.vue'
import dynamic from '../../views/dynamic.vue'
import other from '../../views/other.vue'
import global from '@/utils/global.js'

import { getNewsList, getPicutureNewsList } from '../../api/api'

export default {
  components: { notice, work, dynamic, other },
  name: 'index',
  data() {
    return {
      baseURL: global.fileServer,
      imgList: []
    }
  },
  created() {
    this.getnews()
  },
  methods: {
    getnews() {
      const data = {
        current: 1,
        size: 5
      }
      getPicutureNewsList(data)
        .then(res => {
          console.log(res)
          if (res.code == 200) {
            this.imgList = res.data.records
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    gonew(id) {
      this.$router.push({ path: '/home/news', query: { id: id } })
    }
  }
}
</script>
<style lang="less" scoped>
.block {
  width: 50%;
}
.block div {
  img {
    width: 100%;
    height: 100%;
    // object-fit:cover;
  }
}
.notice {
  width: 50%;
}
.work {
  width: 40%;
  margin-right: 10px;
}
.dynamic {
  width: 40%;
}
.other {
  width: 20%;
  margin-left: 5px;
}
.fixed1 {
  position: fixed;
  top: 270px;
  right: 2px;
}
.fixed2 {
  position: fixed;
  top: 340px;
  right: 2px;
}
</style>
